<rotec-pages-v2>
  <a [routerLink]="searchLink" routerLinkActive="pages-active-link">
    <h3 translate>Protocols</h3>
    <p>
      {{ (searchService.state$ | async).total }}
    </p>
  </a>
  <a
    [routerLink]="compareLink"
    routerLinkActive="pages-active-link"
    *rotecLet="(compareService.state$ | async).selected.length as nrOfRotors"
    [class.pages-inactive-link]="nrOfRotors < 1"
  >
    <h3 translate>Compare</h3>
    <p>{{ nrOfRotors }}</p>
  </a>
  @if (userRightsService.hasActionRights$(actions.readTemplate) | async) {
    <a
      [routerLink]="editLink"
      routerLinkActive="pages-active-link"
      *rotecLet="numberOfTemplates$ | async as nrOfTemplates"
    >
      <h3 translate>Templates</h3>
      <p>{{ nrOfTemplates }}</p>
    </a>
  }
</rotec-pages-v2>
